import React, { Component } from 'react';
import Wrp from "../../hoc/Wrp/Wrp";
import Select from "react-select";
import {setAndGetAttributes} from './FormInputFunctions';
// import makeAnimated from "react-select/animated";
import { isSet } from '../../Utils/CommonFunctions';

class MultiChoose extends Component {

   fieldOnChangeHandler = (options,values)=>{
    console.log('fieldOnChangeHandler',options,values)
    const {changeHandler} = this.props;
    switch ((values!==undefined)?values.action:'others') {
      case 'remove-value':
        if (values.removedValue.isFixed===true) {
          return;
        }
      case 'pop-value':
        if (values.removedValue.isFixed===true) {
          return;
        }
        break;
      case 'clear':
        options = options.filter((v)=>{
          if(v.isFixed!==true){
            return v;
          }
        })
        break;
    }
    //console.log(options[0].value);
    let valueArr = []
    if(isSet(options,[]).length>0){
      options.map((item,index)=>{
        valueArr.push(item.id)
      })
    }
    changeHandler(valueArr,true);
  } 
  
  render() {
    const {value,options} = this.props;
    // const animatedComponents = makeAnimated();
    let attr = setAndGetAttributes(this.props);
    //console.log('value==',value);
    //console.log('options==',options)
    let optionArr = [];
    let selOptionArr = [];
    if(isSet(options,[]).length>0){
      options.map((opt,ind) => {
        let optObj = {
          id:opt.id,
          value:opt.id,
          label:opt.value,
          text:opt.value,
        }
        optionArr.push(optObj);

        if(isSet(value,null)!==null){
          if(value.indexOf(opt.id)!==-1 ){
            selOptionArr.push(optObj); 
          }
        }

      })
    }
    
    return (
      
      <Wrp>
        <div className={(this.props.isMandatory && this.props.isMandatory===true)? "mandatory" : "" }>
          <Select 
              isMulti={true}
              classNamePrefix="form-control"
              onChange={e=>this.fieldOnChangeHandler(e)}
              {...attr}
              className=''
              isClearable={false}
              options={optionArr}
              value={selOptionArr}
              //components={animatedComponents}
          />
        </div>
      </Wrp>        
   );
  }
}

MultiChoose.defaultProps = {
  disabled: false,
  readOnly:false,
  className: 'form-control'
}

export default MultiChoose;

